import React, { useState } from "react";
import { App } from "antd";
import { PACKAGES, useSearch } from "../../../../contexts/SearchContext";
import {
  PACKAGE_QUICK_CATEGORY_ITEMS,
  filterVisiblePackageQuickCategories,
} from "../../../../constants/packageQuickCategoryItems";
import PackageQuickCategoryGrid from "./PackageQuickCategoryGrid";
import "./QuickSearchBlock.css";

/**
 * כפתורי "חיפוש מהיר" לפי קטגוריית חבילה — חלק ממנוע החיפוש (סוכן).
 */
const QuickSearchBlock = () => {
  const { notification } = App.useApp();
  const {
    searchTab,
    searchByCategory,
    subjects,
    destinations,
    setSearchTab,
  } = useSearch();

  const [loadingCategory, setLoadingCategory] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const availableCategories = subjects?.FlightsHotel || [];
  const visible = filterVisiblePackageQuickCategories(
    availableCategories,
    PACKAGE_QUICK_CATEGORY_ITEMS
  );

  if (searchTab !== PACKAGES || visible.length === 0) {
    return null;
  }

  const handleCategoryClick = async (category) => {
    if (loadingCategory) return;
    setSelectedCategory(category.key);
    setLoadingCategory(category.key);

    try {
      if (searchTab !== PACKAGES) {
        setSearchTab(PACKAGES, { source: "user_click" });
        await new Promise((resolve) => setTimeout(resolve, 200));
      }

      if (!destinations || destinations.length === 0) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        if (!destinations || destinations.length === 0) {
          notification.warning({
            message: "טוען יעדים...",
            description: "אנא נסה שוב בעוד רגע",
            duration: 3,
          });
          return;
        }
      }

      if (searchByCategory) {
        await searchByCategory(category.key, 6);
      } else {
        notification.error({
          message: "שגיאה",
          description: "פונקציית החיפוש לא זמינה",
          duration: 5,
        });
      }
    } catch (error) {
      notification.error({
        message: "שגיאה בחיפוש",
        description: `אירעה שגיאה בעת חיפוש ${category.label}`,
        duration: 5,
      });
    } finally {
      setLoadingCategory(null);
    }
  };

  return (
    <PackageQuickCategoryGrid
      subjectsFlightsHotel={availableCategories}
      selectedKey={selectedCategory}
      loadingKey={loadingCategory}
      onCategoryClick={handleCategoryClick}
      showHeader
      headerLabel="חיפוש מהיר"
    />
  );
};

export default QuickSearchBlock;
